import routes from "@/constants/routes";
import { getAuthUser } from "@/services/api";
import { queryClient } from "@/services/queryClient";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useQuery } from "react-query";

interface UseAuthOptions {
  redirectOnUnauth?: boolean;
}

export const useAuth = ({ redirectOnUnauth = true }: UseAuthOptions = {}) => {
  const router = useRouter();
  const redirected = useRef(false);

  const { data, isLoading, error } = useQuery(["auth"], getAuthUser, {
    retry: false,
    refetchOnWindowFocus: true,
    staleTime: 0,
    onError: (error: any) => {
      if (error?.response?.status !== 401) return;

      queryClient.setQueryData(["auth"], null);

      if (!redirectOnUnauth) return;

      // If the user is not authenticated, redirect to the magic link page
      const isLoginPage = router.asPath.startsWith(routes.dashboard.login);
      if (!redirected.current && !isLoginPage) {
        redirected.current = true;
        queryClient.clear();
        localStorage.removeItem("token");
        router.replace(routes.dashboard.login);
      }
    },
  });

  const isSessionExpired = (error as any)?.response?.status === 401;

  return {
    user: isSessionExpired ? null : data ?? null,
    isAuthenticated: !!data && !isSessionExpired,
    isLoading,
  };
};
